import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "AIzaSyAokJk9lGSaNDFEvkRfjCeU98Q3OevKlz4",
//   authDomain: "healthbox-61f27.firebaseapp.com",
//   projectId: "healthbox-61f27",
//   storageBucket: "healthbox-61f27.firebasestorage.app",
//   messagingSenderId: "551412109546",
//   appId: "1:551412109546:web:0794ef575bf2db8ec8c793",
//   measurementId: "G-YL7DJF9PRV"
//   // measurementId: 'G-YL7DJF9PRV',
// }
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
// export const firebaseConfig = () => {};

// if (!("Notification" in window)) {
//   console.log("This browser does not support system notifications.");
// } else if (Notification.permission === "granted") {
//   // If it's okay let's create a notification
//   var notification = new Notification(
//     notificationTitle,
//     notificationOptions
//   );
//   notification.onclick = function (event) {
//     event.preventDefault();
//     window.open("https://google.com", "_blank");
//     notification.close();
//   };
// }
